// 都道府県とリードタイムを紐付けるための設定ファイル。
// 都道府県ID:リードタイム（日数）
window.CustomDeliveryDatetime.settings.LEAD_TIMES.NORMAL = {
    1:6,
    2:2,
    3:2,
    4:2,
    5:2,
    6:2,
    7:2,
    8:2,
    9:2,
    10:2,
    11:2,
    12:2,
    13:2,
    14:2,
    15:2,
    16:2,
    17:2,
    18:2,
    19:2,
    20:2,
    21:2,
    22:2,
    23:2,
    24:2,
    25:2,
    26:2,
    27:2,
    28:2,
    29:2,
    30:2,
    31:2,
    32:2,
    33:2,
    34:2,
    35:2,
    36:2,
    37:2,
    38:2,
    39:2,
    40:2,
    41:2,
    42:2,
    43:2,
    44:2,
    45:2,
    46:2,
    47:13,
};

// 関東在庫の場合に、減らすリードタイム
// 例:配送先東京都(13)の場合、通常（LEAD_TIMES.normal.13）で4日で、関東在庫の場合、（LEAD_TIMES.kanto.13）の設定の1を減らして3日になる。
// 都道府県ID:減算するリードタイム（日数）

window.CustomDeliveryDatetime.settings.LEAD_TIMES.KANTO = {
    8:1,
    9:1,
    10:1,
    11:1,
    12:1,
    13:1,
    14:1,
    21:1,
    22:1,
    23:1,
    24:1,
    25:1,
    26:1,
    27:1,
    28:1,
    29:1,
    30:1,
};
// 九州在庫の場合に、減らすリードタイム
// 関東在庫同様にマイナスする日数を設定する
// 都道府県ID:減算するリードタイム（日数）
window.CustomDeliveryDatetime.settings.LEAD_TIMES.KYUSHU = {
    26:1,
    27:1,
    28:1,
    29:1,
    33:1,
    34:1,
    35:1,
    40:1,
    41:1,
    42:1,
    43:1,
    44:1,
    45:1,
    46:1,
};
// 関東、九州両方に存在する在庫の場合に、減らすリードタイム
// 関東在庫同様にマイナスする日数を設定する
// 都道府県ID:減算するリードタイム（日数）
window.CustomDeliveryDatetime.settings.LEAD_TIMES.KANTO_KYUSHU = {
    8:1,
    9:1,
    10:1,
    11:1,
    12:1,
    13:1,
    14:1,
    21:1,
    23:1,
    22:1,
    24:1,
    25:1,
    26:1,
    27:1,
    28:1,
    29:1,
    30:1,
    33:1,
    34:1,
    35:1,
    40:1,
    41:1,
    42:1,
    43:1,
    44:1,
    45:1,
    46:1,
};
